import { render, staticRenderFns } from "./rightBtn.vue?vue&type=template&id=1ac61481&"
import script from "./rightBtn.vue?vue&type=script&lang=js&"
export * from "./rightBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "rightBtn.vue"
export default component.exports